import React from 'react';

const Hero = () => {
  return (
    <section id="home">
      <div className="hero-wrap" style={{position: 'relative', overflow: 'hidden', minHeight: '100vh'}}>
        <video autoPlay muted loop playsInline style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0}}>
          <source src="/iot8.mp4" type="video/mp4" />
        </video>
        <div className="hero-content d-flex flex-column fullscreen" style={{position: 'relative', zIndex: 2}}>
          <div className="container my-auto">
            <div className="row pt-5">
              <div className="col-12 text-center">
   <h2 
  className="text-20 font-weight-200 text-uppercase text-white mb-2 mb-md-3" 
  style={{ fontFamily: '"Century Gothic", sans-serif' }}
>
  Rovo <br/> Automation
</h2>
                <p className="lead text-light mb-3 mb-md-5">Transforming Industries with Smart IoT & Automation Solutions!</p>
                {/* <a href="#work" className="btn btn-primary text-2 rounded-pill smooth-scroll">View Our Work</a> */}
              </div>
            </div>
          </div>
          <div className="container py-2 text-center">
            <a href="#about" className="text-light text-4 smooth-scroll"><i className="fa fa-chevron-down"></i></a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
